import React, { ReactElement, useContext } from 'react';
import { LoaderMask } from 'components/LoaderMask/LoaderMask';
import { WidgetGeneratorContext } from 'screens/WidgetGenerator/contexts/WidgetGeneratorContext';
import { AreasSentimentBarTableWidgetData } from 'screens/WidgetGenerator/utils/misc';
import { AreasSentimentBarTable } from 'screens/WidgetGenerator/widgets/SentimentBarTable/AreasSentimentBarTable';

import { getAreasScoreData } from 'screens/WidgetGenerator/helpers/areasScore';
import { useAsyncEffect } from 'customHooks/hooks';
import { logger } from 'utils/logger';
import { isFirstCycle } from 'screens/WidgetGenerator/utils/cycles';

const DEFAULT_DATA: AreasSentimentBarTableWidgetData[] = [
  {
    id: '0',
    name: '',
    totalSubmissions: 0,
    score: {
      positive: 0,
      negative: 0,
      neutral: 0,
    },
    previousCycle: {
      score: {
        positive: 0,
        negative: 0,
        neutral: 0,
      },
    },
  },
];

export const AreasSentimentBarTableHOC = (): ReactElement => {
  const { client, cycles, selectedDateRange } = useContext(WidgetGeneratorContext);

  const fetchAreasData = async () => {
    const fetchedAreasScoreData = await getAreasScoreData(client, cycles, selectedDateRange);
    return fetchedAreasScoreData;
  };

  const {
    fetchedData: fetchedAreasScoreData,
    isLoading,
    error,
  } = useAsyncEffect(fetchAreasData, [client, cycles, selectedDateRange]);

  if (error) {
    logger.error(error);
  }

  const hasPreviousCycle = !isFirstCycle(selectedDateRange, cycles);

  return (
    <LoaderMask isLoading={isLoading}>
      <AreasSentimentBarTable widgetData={fetchedAreasScoreData ?? DEFAULT_DATA} isBenchmarked={hasPreviousCycle} />
    </LoaderMask>
  );
};
